var poll_header_default = {
  "title": "ljWs-",
  "image": "ePj3I",
  "webview": "eG-oL"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
